import { Command } from 'commander';
import inquirer from 'inquirer';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { resolveSpaceIdBySlug } from './show.js';
import { resolveUserIdByEmail } from '../_members-resolver.js';

interface RemoveOpts { skipConfirm?: boolean; org?: string; }

export async function runSpaceRemove(slug: string, email: string, opts: RemoveOpts, client?: IV2Client): Promise<void> {
  if (!opts.skipConfirm) {
    const { ok } = await inquirer.prompt([{ type: 'confirm', name: 'ok',
      message: `Remove ${email} from space "${slug}"? Inspirations they own remain.`, default: false }]);
    if (!ok) { process.stdout.write('Cancelled.\n'); return; }
  }
  const c = client ?? await getV2Client(opts.org ?? undefined);
  const spaceId = await resolveSpaceIdBySlug(c, slug);
  const userId = await resolveUserIdByEmail(c, email);
  await c.del(`/api/v2/spaces/${spaceId}/members/${userId}`);
  process.stdout.write(`✓ Removed ${email} from ${slug}.\n`);
}

export const spaceRemoveCommand = new Command('remove')
  .description('Remove a member from a space (admin only)')
  .argument('<slug>', 'Space slug')
  .argument('<email>', 'Email of member to remove')
  .option('--skip-confirm', "Don't prompt for confirmation")
  .option('--org <slug>', 'Override active grid')
  .action(async (slug: string, email: string, opts: RemoveOpts) => {
    try { await runSpaceRemove(slug, email, opts); }
    catch (err) { await handleV2Error(err); }
  });
